import token, { tokenToVars } from '../token';
import Empty from './empty';

export { Empty };
export default tokenToVars(Empty, token);
